var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.8438H22V22.6562H14V20.8438ZM10 20.8438H12V22.6562H10V20.8438ZM14 16.3125H22V18.125H14V16.3125ZM10 16.3125H12V18.125H10V16.3125ZM14 11.7812H22V13.5938H14V11.7812ZM10 11.7812H12V13.5938H10V11.7812Z",
    fill: "#0761AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 4.53125H22V3.625C22 3.1443 21.7893 2.68328 21.4142 2.34337C21.0391 2.00346 20.5304 1.8125 20 1.8125H12C11.4696 1.8125 10.9609 2.00346 10.5858 2.34337C10.2107 2.68328 10 3.1443 10 3.625V4.53125H7C6.46957 4.53125 5.96086 4.72221 5.58579 5.06212C5.21071 5.40203 5 5.86305 5 6.34375V25.375C5 25.8557 5.21071 26.3167 5.58579 26.6566C5.96086 26.9965 6.46957 27.1875 7 27.1875H25C25.5304 27.1875 26.0391 26.9965 26.4142 26.6566C26.7893 26.3167 27 25.8557 27 25.375V6.34375C27 5.86305 26.7893 5.40203 26.4142 5.06212C26.0391 4.72221 25.5304 4.53125 25 4.53125ZM12 3.625H20V7.25H12V3.625ZM25 25.375H7V6.34375H10V9.0625H22V6.34375H25V25.375Z",
    fill: "#0761AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.2e6cc839.svg";
export { ForwardRef as ReactComponent };